export {
  GRAPHEME_LINK_SCHEME,
  addMnemonicGlyphBadges,
  collectBracketTexts,
  getMnemonicGraphemeLabel,
  parseGraphemeFromDescriptionLinkUrl,
  preprocessBracketLinks,
} from "#description";
